var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefits1Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 40,
    viewBox: "0 0 120 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3337 30.0001V16.6668C33.3337 13.5235 33.3337 11.9518 32.357 10.9768C31.3803 10.0001 29.8103 10.0001 26.667 10.0001H6.66699V30.0001C6.66699 33.1418 6.66699 34.7135 7.64366 35.6901C8.62033 36.6668 10.1903 36.6668 13.3337 36.6668H26.667C29.8103 36.6668 31.3803 36.6668 32.357 35.6901C33.3337 34.7135 33.3337 33.1418 33.3337 30.0001Z",
    stroke: "#FC6430",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0003 18.3335C21.3264 18.3335 22.5982 18.8602 23.5359 19.7979C24.4735 20.7356 25.0003 22.0074 25.0003 23.3335M20.0003 18.3335C18.6742 18.3335 17.4025 18.8602 16.4648 19.7979C15.5271 20.7356 15.0003 22.0074 15.0003 23.3335M20.0003 18.3335V16.6668M25.0003 23.3335H15.0003M25.0003 23.3335H26.667M15.0003 23.3335H13.3337M13.3337 30.0001H26.667M6.66699 10.0001L18.9753 4.84345C21.7237 3.69179 23.097 3.11512 24.192 3.41012C24.9019 3.60091 25.5289 4.02104 25.9753 4.60512C26.667 5.50845 26.667 7.00512 26.667 10.0001",
    stroke: "#FC6430",
    strokeWidth: 2.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 10.0001V30.0001M105 15.8335C105 13.5335 102.762 11.6668 100 11.6668C97.2383 11.6668 95 13.5335 95 15.8335C95 18.1335 97.2383 20.0001 100 20.0001C102.762 20.0001 105 21.8668 105 24.1668C105 26.4668 102.762 28.3335 100 28.3335C97.2383 28.3335 95 26.4668 95 24.1668",
    stroke: "#FC6430",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6663 5.56352C94.1988 4.09806 97.0738 3.32869 99.9997 3.33352C109.205 3.33352 116.666 10.7952 116.666 20.0002C116.666 29.2052 109.205 36.6668 99.9997 36.6668C90.7947 36.6668 83.333 29.2052 83.333 20.0002C83.333 16.9652 84.1447 14.1168 85.563 11.6669",
    stroke: "#FC6430",
    strokeWidth: 2.6,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3998 20C66.3998 24.86 62.4598 28.8 57.5998 28.8C52.7398 28.8 48.7998 24.86 48.7998 20C48.7998 15.14 52.7398 11.2 57.5998 11.2C62.4598 11.2 66.3998 15.14 66.3998 20ZM61.8318 18.8H58.3998V13.9432L53.3678 21.2H56.7998V26.0568L61.8318 18.8Z",
    fill: "#FFAC90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2666 20.2935L37.5999 20.2935",
    stroke: "#FFAC90",
    strokeWidth: 1.3619,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.999 17.1339C74.0252 17.134 74.0507 17.1391 74.0742 17.1486L74.1348 17.1876H74.1357L77.2305 20.1818C77.2471 20.1978 77.2594 20.2164 77.2676 20.2355C77.2757 20.2545 77.2803 20.2744 77.2803 20.2941C77.2802 20.3137 77.2757 20.3337 77.2676 20.3527L77.2305 20.4054V20.4064L74.1357 23.3995C74.1019 23.4323 74.0529 23.4531 73.999 23.4532C73.945 23.4532 73.8953 23.4324 73.8613 23.3995C73.8281 23.3672 73.8125 23.3264 73.8125 23.2872C73.8125 23.2677 73.8161 23.2477 73.8242 23.2286L73.8613 23.1749L75.9004 21.2042L76.6709 20.4591H69.666C69.6122 20.4591 69.5631 20.4381 69.5293 20.4054C69.4962 20.3733 69.4806 20.333 69.4805 20.2941C69.4805 20.255 69.496 20.214 69.5293 20.1818C69.5631 20.1491 69.6122 20.1281 69.666 20.1281H76.6709L75.9004 19.3839L73.8613 17.4122L73.8242 17.3585C73.8161 17.3395 73.8115 17.3196 73.8115 17.2999C73.8115 17.2803 73.8161 17.2603 73.8242 17.2413L73.8613 17.1876H73.8623C73.8789 17.1715 73.8993 17.158 73.9229 17.1486C73.9465 17.1391 73.9726 17.1339 73.999 17.1339Z",
    fill: "#FC6430",
    stroke: "#FFAC90",
    strokeWidth: 0.866667
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits1Icon);
export default __webpack_public_path__ + "static/media/benefits1 icon.9139ac840d1d6d114eaf553bf22049d0.svg";
export { ForwardRef as ReactComponent };